import { NavLink } from "react-router-dom";

import InfoComponent from '../InfoComponent'
import ListedItemsItem2 from '../ListedItemsItem2'
import {ListedItemsData} from '../../data/data-components/data-ListedItems.js'
// import ListedItemsData from './data.json'

import './listedItems.css'

function ListedItemsContainer(){

  // console.log(ListedItemsData , ListedItemsData[0].imgSm)

  return(
    <div className="features col-12 col-lg-9">

        <div className="container">
            <InfoComponent
              titleSm='Created New Items'
              titleLg='New Created Items'
              text='Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed quis accumsan nisi Ut ut felis congue nisl hendrerit commodo.'
            />

            <div className="row align-items-center">
            	{ListedItemsData && ListedItemsData.map((item , i) => (
	                <ListedItemsItem2
	                	imgBig={item.imgBig}
	                	imgSm={item.imgSm}
	                	title={item.title}
	                	price={item.price}
	                	bid={item.bid}
	                />
            	))}
                <div className="col-12 col-lg-12 text-center">
                    <NavLink className="btn more-btn" to="/discover">Load More</NavLink>
                </div>
            </div>
            
        </div>
    </div>
  )
}

export default ListedItemsContainer